import { MAX_STREAM_TO_LOOKBACK_MS, STREAM_RANGE_DURATION_MS } from '../../consts';
import { useLoadRange } from './useLoadRange';

export function useLoadRangeAtStartTs() {
  const loadRange = useLoadRange();

  return (fromTs: number) => {
    const maxAllowedTo = Date.now() - MAX_STREAM_TO_LOOKBACK_MS;
    const from = Math.min(fromTs, maxAllowedTo);

    const requestedTo = from + STREAM_RANGE_DURATION_MS;
    const to = Math.min(requestedTo, maxAllowedTo);

    return loadRange(from, to);
  };
}
